import { StudyLevel } from '~/services/CSPService';
import { IComparer } from '.';

export default class StudyProgramLevelComparer implements IComparer<StudyLevel | undefined> {
    static studyLevelLabels: Record<string, number> = {
        phd: 0,
        dba: 1,
        master: 2,
        mba: 3,
        bachelor: 4,
        diploma: 5,
        certification: 6,
        microcredential: 7,
    };

    compare(x: StudyLevel | undefined, y: StudyLevel | undefined): number {
        if (!x && !y) {
            return 0;
        }

        if (!x) {
            return 1;
        }

        if (!y) {
            return -1;
        }

        const xLabel = x.name.toLowerCase();
        const yLabel = y.name.toLowerCase();
        const xLevel =
            xLabel in StudyProgramLevelComparer.studyLevelLabels
                ? StudyProgramLevelComparer.studyLevelLabels[xLabel]
                : Number.MAX_VALUE;
        const yLevel =
            yLabel in StudyProgramLevelComparer.studyLevelLabels
                ? StudyProgramLevelComparer.studyLevelLabels[yLabel]
                : Number.MAX_VALUE;

        return xLevel - yLevel;
    }
}
